import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import KnowledgeBaseViewPage from "../../Sections/KnowledgeBase/KnowledgeBaseViewPage"

const KnowledgeBaseViewComponent = () => {
  return <Dashboard sectionName={<KnowledgeBaseViewPage />} />;
};

export default KnowledgeBaseViewComponent;
